/**
 * Hampers by budget: tab switching.
 *
 * Follows the ARIA tabs pattern: click or arrow keys move between budget tabs, and only the
 * selected tab is in the tab order. Without JS the first tier still shows.
 */
if (!customElements.get('hamper-price-tiers')) {
  customElements.define(
    'hamper-price-tiers',
    class HamperPriceTiers extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.onClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab) this.select(tab);
        };
        this.onKeydown = (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index === -1) return;

          let next;
          if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
          if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
          if (event.key === 'Home') next = this.tabs[0];
          if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
          if (!next) return;

          event.preventDefault();
          this.select(next);
          next.focus();
        };

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
      }

      select(selectedTab) {
        this.tabs.forEach((tab) => {
          const selected = tab === selectedTab;
          tab.setAttribute('aria-selected', selected);
          tab.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      }
    }
  );
}
